@if (tenantSg()) {
  @let submissionError =
    tenantsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-centered-overlay>
    <atn-ds-widget [title]="titleSg()">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelClickHandler()"
      ></i>
      <div class="atn-admin-tenant__content">
        <atn-ds-text
          label="Name"
          placeholder="Enter a name"
          [value]="nameSg()"
          (change)="updateTenant('name', $event ?? '')"
          data-test-id="name-label"
        />
        <atn-ds-text
          label="Alias"
          placeholder="Enter an alias"
          [value]="aliasSg()"
          (change)="updateTenant('alias', $event ?? '')"
          data-test-id="alias-label"
        />
        <atn-ds-text
          label="Code"
          placeholder="Enter a code"
          [value]="codeSg()"
          (change)="updateTenant('code', $event ?? '')"
          data-test-id="code-label"
        />

        <atn-ds-colorpicker
          label="Theme Color"
          [value]="colorSg()"
          (valueChange)="updateTenant('color', $event ?? '')"
        />
        <atn-admin-error-message [message]="submissionError" />
      </div>
      <div
        class="atn-admin-tenant__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveClickHandler()"
          [loading]="
            tenantsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal()
          "
        >
          Save
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
